export const DEFAULT_POLLING_INTERVAL_MILLIS = 2000;
